export const eventsTemplate = `Type,Dato,Kjøper,E-post kjøper,investorid kjøper,Selger,E-post selger,investorid selger,Antall,Pris,Aksjeklasse,Aksjenummer,Adresse kjøper,Postnr kjøper,Poststed kjøper,Telefonnummer kjøper,Land kjøper,VPS-nummer kjøper,LEI-nummer kjøper,Adresse selger,Postnr selger,Poststed selger,Telefonnummer selger,Land selger,VPS-nummer selger,LEI-nummer selger,Fra,Til,Strategi
Stiftelse,2022-01-01 10:00,Selskap AS,selskap@email.no,256123985,,,,10,100,Ordinære aksjer,11-20,,,,,Norge,,,,,,,,,,,,
Stiftelse,2022-01-01 10:00,Aksjonær Eiersen,eier@email.com,231195,,,,10,100,Ordinære aksjer,1-10,,,,,Norge,,,,,,,,,,,
Emisjon,2022-01-02 10:00,Selskap AS,selskap@email.no,256123985,,,,10,150,Ordinære aksjer,21-30,,,,,Norge,,,,,,,,,,,,
Emisjon,2022-01-02 10:00,Eier Aksjonærsen,eier2@email.com,010195,,,,10,150,Ordinære aksjer,31-40,Bodøveien 1,0202,Bodø,8791212789,Norge,,,,,,,,,,,,
Splitt,2022-01-03 10:00,,,,,,,,,,Ordinære aksjer,,,,,,,,,,,,,,,1,2,ned
Spleis,2022-01-03 11:00,,,,,,,,,,Ordinære aksjer,,,,,,,,,,,,,,,2,1,opp
Kjøp/salg,2022-12-12,Selskap AS,selskap@email.no,256123985,Aksjonær Eiersen,eier@email.com,231195,10,150,Ordinære aksjer,,,,,,Norge,,,,,,,Norge,,,,,
Arv uten skattemessig kontinuitet,2022-12-15 10:00,Selskap AS,selskap@email.no,256123985,Eier Aksjonærsen,eier2@email.com,10109522222,5,230,Ordinære aksjer,,,,,,Norge,,,,,,,,,,,
Konsernintern overføring,2022-12-16 10:00,Eier Aksjonærsen,eier2@email.com,10109522222,Selskap,selskap@email.no,256123985,5,190,Ordinære aksjer,,,,,,,,,,,,,,,,,
Slett,2022-12-17,,,,Aksjonær Eiersen,eier@email.com,231195,10,,Ordinære aksjer,,,,,,,,,,,,,,,,,`;

export const translatedHeaderMap = {
  type: 'Type',
  date: 'Dato',
  buyer: 'Kjøper',
  buyeremail: 'E-post kjøper',
  buyerinvestorid: 'Fødselsnummer/orgnr kjøper',
  buyeraddress: 'Adresse kjøper',
  buyerzip: 'Postnr kjøper',
  buyercity: 'Poststed kjøper',
  buyertlf: 'Telefonnummer kjøper',
  buyercountry: 'Land kjøper',
  buyervps: 'VPS-nummer kjøper',
  buyerlei: 'LEI-nummer kjøper',
  seller: 'Selger',
  selleremail: 'E-post selger',
  sellerinvestorid: 'Fødselsnummer/orgnr selger',
  selleraddress: 'Adresse selger',
  sellerzip: 'Postnr selger',
  sellercity: 'Poststed selger',
  sellertlf: 'Telefonnummer selger',
  sellercountry: 'Land selger',
  sellervps: 'VPS-nummer selger',
  sellerlei: 'LEI-nummer selger',
  amount: 'Antall',
  price: 'Pris',
  shareclass: 'Aksjeklasse',
  notes: 'Aksjenummer',
  from: 'Fra',
  to: 'Til',
  strategy: 'Strategi',
};
